<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide" persistent>
    <q-card
      class="q-dialog-plugin border-card"
      style="min-width: 340px; max-width: 440px"
    >
      <q-card-section class="column items-center text-center q-gutter-y-sm">
        <q-icon name="inventory" size="64px" class="text-brand" />
        <div class="text-h6 text-bold">Stock Opname Sedang Berjalan</div>
        <div class="l-text-description text-grey-7">
          Fitur ini sementara tidak dapat diakses karena sedang ada Stock
          Opname berjalan<span v-if="kode"> ({{ kode }})</span>. Silakan
          kembali setelah opname selesai.
        </div>
      </q-card-section>

      <q-card-section class="bg-grey-3" style="padding-top: 16px !important">
        <q-btn
          unelevated
          no-caps
          class="full-width"
          color="brand"
          label="Kembali ke Beranda"
          @click="kembali"
        ></q-btn>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { useDialogPluginComponent } from "quasar";
import useBasic from "@/composables/useBasic";

// Dialog persistent penutup halaman ber-meta opnameLock (lihat App.vue).
// Satu-satunya jalan keluar = tombol kembali ke beranda.
export default {
  props: {
    // kode sesi SO yang sedang berjalan (mis. "SO-0805-A"), boleh kosong
    kode: { type: String, default: "" },
  },
  emits: [...useDialogPluginComponent.emits],

  setup() {
    const { dialogRef, onDialogHide, onDialogOK } = useDialogPluginComponent();
    const { router } = useBasic();

    let kembali = () => {
      onDialogOK();
      router.push("/");
    };

    return { dialogRef, onDialogHide, kembali };
  },
};
</script>
